import React from 'react';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

import ContainerTab from '../../components/ContainerTab';
import ProfileScreen from '../../screens/TabScreen/ProfileScreen';
import EditProfileScreen from '../../screens/TabScreen/ProfileScreen/screens/EditProfileScreen';
import ChangePasswordScreen from '../../screens/TabScreen/ProfileScreen/screens/ChangePasswordScreen';
import HomeScreen from '../../screens/TabScreen/HomeScreen';

const Tab = createMaterialTopTabNavigator();
const Stack = createNativeStackNavigator();

function ProfileStack() {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="ProfileScreen" component={ProfileScreen} />
      <Stack.Screen
        name="ChangePasswordScreen"
        component={ChangePasswordScreen}
      />
      <Stack.Screen name="EditProfileScreen" component={EditProfileScreen} />
    </Stack.Navigator>
  );
}

function MainTabVisitor() {
  const profileOption = {title: '', gestureEnabled: false};

  const tabBar = (props: any) => {
    return <ContainerTab {...props} />;
  };

  return (
    <Tab.Navigator
      tabBar={tabBar}
      tabBarPosition="bottom"
      screenOptions={{
        swipeEnabled: false,
      }}>
      <Tab.Screen
        component={HomeScreen}
        name="HomeScreen"
        options={profileOption}
      />
      <Tab.Screen
        component={ProfileStack}
        name="ProfileStack"
        options={profileOption}
      />
    </Tab.Navigator>
  );
}

export default MainTabVisitor;
